import superMeta from '../_COMMON/metaCommonNode.mjs'

export default {
    ...superMeta,
    name: '子项目',
    type: 'SPJ',
    textProp: 'prjName',
}
